import { render, staticRenderFns } from "./CommunicationTemplates.vue?vue&type=template&id=1f2c882c&"
import script from "./CommunicationTemplates.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports